import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, requiredRole, fallback }) => {
  const { user, loading, role, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#070A0F]">
        <Loader2 className="h-10 w-10 animate-spin text-[#C6A75E] mb-4" />
        <p className="text-[#C6A75E] font-medium tracking-widest">VERIFICANDO ACESSO...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/system/login" state={{ from: location }} replace />;
  }

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!roles.includes(role) && !isSuperAdmin) {
      if (fallback) return fallback;
      return <Navigate to="/system/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;